/**
 * Checks if an array contains any items.
 * @param {Array} arr The array to check.
 * @returns True, if the array contains items. Otherwise, false.
 */
const isNonEmptyArray = (arr) => {
  return arr && Array.isArray(arr) && arr.length > 0
}

export { isNonEmptyArray }
